<template>
	<div class="content" style="background-color: #FFF;display: flex;justify-content: center;align-items: center;">
		<qrcode-stream @decode="onDecode" @detect="onDetect" style="width:450px;height: 100%;"></qrcode-stream>
	</div>
</template>

<script>
	export default {
		components: {
		},
		data() {
			return {
				show: true,
				loading: "",
				interval: null
			}
		},
		created() {

		},
		methods: {
			onDetect(promise) {
				var self = this;
				promise.then(data => {
					// console.log(data);
				})
				// console.log("hi");
			},
			onDecode(qr) {
				console.log(qr);
				if (String(qr).length > 5 && String(qr).length < 10) {
					this.$http.post(this.config.api + "/admin/ticket/search", {
						text: String(qr),
						status: "",
						offset: 0
					}).then(data => {
						if (data.body.data.length > 0) {
							this.$router.push("/passes/detail/" + data.body.data[0].hash_id);
						}
					})
				}
			},
		}
	}
</script>
<style>
	body {
		background-color: #FFF !important;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Passes/Scan.vue